import { Form, Select, Input, DatePicker } from "antd";
import React, { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";

import { shouldShowComponent } from "../../../utils/componentVisibility";

const UserDetailsFields = (props) => {
  const shouldShow = shouldShowComponent(config.project, "UserDetailsFields");

  const storeContext = useContext(StoreContext); // Use the context here

  if (!shouldShow) {
    return (
      <Form.Item
        name="name"
        className="uploadCompany"
        label={
          <span>
            {storeContext.translate("_FLEET_DASHBORD_NEWPOI_NAME_")}{" "}
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        required={false}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    );
  }

  return (
    <>
      <Form.Item
        className="uploadCompany"
        name="dobFormat"
        // label="DOB Format"
        label={storeContext.translate("_DOB_FORMATE_")}
      >
        <Select
          // placeholder="Select DOB Format"
          placeholder={storeContext.translate("_SELECT_DOB_FORMAT_")}
        >
          <Select.Option value="Hijri">
            Hijri
            {/* {this.context.translate("_HIJRI_")} */}
          </Select.Option>
          <Select.Option value="Gregorian">
            Gregorian
            {/* {this.context.translate("_GREGORIAN_")} */}
          </Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        name="dob"
        className="uploadCompany"
        // label="Date Of Birth"
        label={storeContext.translate("_DOB_LABEL_")}
        rules={[{ type: Date }]}
      >
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>
    </>
  );
};

UserDetailsFields.contextType = StoreContext;
export default observer(withRouter(UserDetailsFields));
